import React, {useCallback, useMemo} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useLocalesMgr, useMedia} from 'coreHooks';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import globalMessages from 'brand/app/components/messages';

import messages from './messages';
import {CountryLanguageTriggerItem, FooterSelectorsItem} from './Subcomponents';

import styles from './FooterSelectors.module.scss';

const FooterSelectors = () => {
	const {managerRepository} = useGeneralProvider();
	const localesMgr = useLocalesMgr();
	const currentLocale = localesMgr.getCurrentLocale();
	const intl = useIntl();
	const media = useMedia();
	const currentCountryCode = currentLocale.getCountryCode();
	const currentLanguageCode = currentLocale.getLanguageCode();
	const countryMessage = globalMessages[currentCountryCode];
	const countryValue = useMemo(()=>{
		let countryValueTemp = intl.formatMessage(countryMessage);

		if (media('>=medium', '<x-large')) {
			countryValueTemp = currentCountryCode;
		}

		return countryValueTemp;
	}, [intl, media]);

	const handleOpenCountryFlyout = useCallback(() => {
		managerRepository.getFlyoutsMgr().openFlyout('countrySelector', true);
	}, []);

	const handleOpenLanguageFlyout = useCallback(() => {
		managerRepository.getFlyoutsMgr().openFlyout('languageSelector', true);
	}, []);

	return (
		<>
			<div
				onClick={handleOpenCountryFlyout}
				className={cn(styles['footer__navigation__select'], styles['footer__navigation__select--country'])}
			>
				<span className={styles['footer__navigation__item__label']}>
					{intl.formatMessage(messages.countrySelectorTriggerTitle)}

					<CountryLanguageTriggerItem className={styles['footer__navigation__item__value']}>
						{countryValue}
					</CountryLanguageTriggerItem>
				</span>

			</div>
			<div
				onClick={handleOpenLanguageFlyout}
				className={cn(styles['footer__navigation__select'], styles['footer__navigation__select--language'])}
			>
				<span className={styles['footer__navigation__item__label']}>
					{intl.formatMessage(messages.languageSelectorTriggerTitle)}
				</span>
				<CountryLanguageTriggerItem className={styles.footer__navigation__item__value}>
					{currentLanguageCode}
				</CountryLanguageTriggerItem>
			</div>
		</>
	);
};

FooterSelectors.Item = FooterSelectorsItem;

export default FooterSelectors;